// Added by Sejune Oh on 2020-02-18
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    Button as MaterialUIButton,
    ButtonProps as MaterialUIButtonProps
} from '@material-ui/core'

// Define
import { KeyIndexedObject } from '@/helper/define';

interface ButtonBaseProps {
    customProps?: KeyIndexedObject<string>
}
export type ButtonProps = Partial<MaterialUIButtonProps> & ButtonBaseProps

// Text Button (default)
export const TextButton: FC<ButtonProps> = ({ customProps, ...props }) => {
    return <MaterialUIButton {...customProps} {...props}></MaterialUIButton>
}

// Contained Button
export const ContainedButton: FC<ButtonProps> = ({ customProps, ...props }) => {
    return <MaterialUIButton {...customProps} {...props} variant={'contained'}></MaterialUIButton>
}

// Outlined Button
export const OutlinedButton: FC<ButtonProps> = ({ customProps, ...props }) => {
    return <MaterialUIButton {...customProps} {...props} variant={'outlined'}></MaterialUIButton>
}
